var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavoriteActive = function SvgFavoriteActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "favorite-active_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#favorite-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "M10.806 20.532 9.5 19.377c-1.981-1.779-3.727-3.507-5.237-5.186C2.754 12.514 2 10.767 2 8.951c0-1.393.481-2.567 1.444-3.52C4.407 4.476 5.593 4 7 4c.815 0 1.662.202 2.542.605.88.404 1.699 1.174 2.458 2.31.76-1.136 1.579-1.906 2.459-2.31C15.339 4.202 16.185 4 17 4c1.407 0 2.593.477 3.556 1.43C21.518 6.384 22 7.558 22 8.951c0 1.853-.787 3.636-2.361 5.35a72.675 72.675 0 0 1-5.167 5.076l-1.278 1.155A1.688 1.688 0 0 1 12 21c-.463 0-.861-.156-1.194-.468Z"
  }))));
};
export default SvgFavoriteActive;